import { useContext, useMemo } from "react";
import { appContext, AppContextType } from "./provider";

interface UseAuthReturn {
  user: AppContextType["user"];
  isAuthenticated: boolean;
  /** True while Firebase is still restoring a persisted session. */
  isLoading: boolean;
  logout: AppContextType["logout"];
}

export const useAuth = (): UseAuthReturn => {
  const context = useContext(appContext);

  if (!context) {
    throw new Error("useAuth must be used within an app provider");
  }

  const { user, authResolved, logout } = context;

  return useMemo(
    () => ({
      user,
      isAuthenticated: !!user,
      isLoading: !authResolved,
      logout,
    }),
    [user, authResolved, logout]
  );
};
